import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

const PRESETS = {
  headerImageAspectRatio: '382/120',
  copyFieldHeight: utils.rem(50),
  iconsWrapper: {
    minHeightStart: utils.rem(110),
    minHeightSmall: utils.rem(65),
  },
  urlWidth: {
    start: utils.rem(120),
    xsmall: utils.rem(220),
    small: utils.rem(280),
    medium: utils.rem(330),
  },
  maxHeight: 320,
};

export const StyledReferralViewWrapper = styled.div(({ theme }) => {
  return css`
    padding: ${utils.rem(theme.Spacing.Size.Medium)};
    overflow-x: hidden;

    @media (min-width: ${theme.Screen.Size.Medium}px) {
      padding: unset;
    }
  `;
});

export const StyledTriggerWrapper = styled.div(({ theme }) => {
  return css`
    padding: ${utils.rem(theme.Spacing.Size.Small)};
    border-radius: ${utils.rem(theme.Border.Radius.Medium)};
    background-color: ${theme.Color.Neutrals.Light};

    display: flex;
    flex-direction: column;
    gap: ${utils.rem(theme.Spacing.Size.Small)};
    justify-content: start;
    align-items: start;

    @media (min-width: ${theme.Screen.Size.Medium}px) {
      flex-direction: row;
      align-items: center;
    }
  `;
});

export const StyledButtonWrapper = styled.div(({ theme }) => {
  return css`
    display: flex;
    margin-left: auto;
    margin-right: auto;

    @media (min-width: ${theme.Screen.Size.Medium}px) {
      margin-right: unset;
    }
  `;
});

export const StyledReferralStoryWrapper = styled.div(({ theme }) => {
  return css`
    width: 100%;
    height: 100%;
    background-color: ${theme.Color.Neutrals.Paper};
    padding: ${utils.rem(theme.Spacing.Size.Large)};
  `;
});

export const StyledHeaderImageWrapper = styled.div(({ theme }) => {
  return css`
    aspect-ratio: ${PRESETS.headerImageAspectRatio};
    width: 100%;
    border-radius: ${utils.rem(theme.Border.Radius.Large)};
    overflow: hidden;
    position: relative;
  `;
});

export const StyledHeaderImage = styled.img(({ theme }) => {
  return css`
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
  `;
});

export const StyledHeaderOverlayWrapper = styled.div(({ theme }) => {
  return css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `;
});

export const StyledModalBodyWrapper = styled.div(({ theme }) => {
  return css`
    display: flex;
    flex-direction: column;
    gap: ${utils.rem(theme.Spacing.Size.Medium)};
    justify-content: center;
    align-items: center;
  `;
});

export const StyledTitleWrapper = styled.div(({ theme }) => {
  return css`
    display: flex;
    flex-direction: column;
    gap: ${utils.rem(theme.Spacing.Size.XXSmall)};
    text-align: center;
    justify-content: center;
    align-items: center;
    margin-top: ${utils.rem(theme.Spacing.Size.Medium)};
    margin-bottom: ${utils.rem(theme.Spacing.Size.Small)};
  `;
});

export const StyledReferralActionViewWrapper = styled.div(({ theme }) => {
  return css`
    display: flex;
    flex-direction: column;
    gap: ${utils.rem(theme.Spacing.Size.Medium)};
    border-radius: ${utils.rem(theme.Border.Radius.Medium)};
    width: 100%;
    background-color: ${theme.Color.Neutrals.Light};
    padding: ${utils.rem(theme.Spacing.Size.Medium)};
    margin-top: ${utils.rem(theme.Spacing.Size.Small)};
    margin-bottom: ${utils.rem(theme.Spacing.Size.Small)};
  `;
});

export const StyledANTDStepsWrapperOverride = styled.div(({ theme }) => {
  return css`
    max-height: ${utils.rem(PRESETS.maxHeight)};
    overflow-y: auto;
    ${theme.Scrollbar.Panel};
    & * > .ant-steps-item-title {
      width: 100%;
    }

    & * > .ant-steps-item-subtitle {
      margin-inline-start: unset;
    }
  `;
});

export const StyledCopyUrlWrapper = styled.div(({ theme }) => {
  return css`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: ${utils.rem(theme.Spacing.Size.Medium)};
    padding-right: ${utils.rem(theme.Spacing.Size.XXSmall)};
    width: 100%;
    height: ${PRESETS.copyFieldHeight};
    background-color: ${theme.Color.Neutrals.Paper};
    border-radius: ${utils.rem(theme.Border.Radius.Medium)};
    border: ${utils.rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border};
  `;
});

export const StyledCopyUrlButtonWrapper = styled.div(({ theme }) => {
  return css`
    margin-left: auto;
  `;
});

export const StyledUrlWrapper = styled.div(({ theme }) => {
  return css`
    width: ${PRESETS.urlWidth.start};

    @media (min-width: ${theme.Screen.Size.XSmall}px) {
      width: ${PRESETS.urlWidth.xsmall};
    }
    @media (min-width: ${theme.Screen.Size.Small}px) {
      width: ${PRESETS.urlWidth.small};
    }
    @media (min-width: ${theme.Screen.Size.Medium}px) {
      width: ${PRESETS.urlWidth.medium};
    }
    & span {
      display: block;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  `;
});

export const StyledShareIconsGrid = styled.div(
  ({ theme }) => css`
    width: 100%;
    min-height: ${PRESETS.iconsWrapper.minHeightStart};
    display: grid;
    height: 100%;
    overflow-y: auto;
    grid-template-columns: repeat(
      auto-fill,
      minmax(calc(25% - ${utils.rem(theme.Spacing.Size.MediumSmall)}), 1fr)
    );
    gap: ${utils.rem(theme.Spacing.Size.MediumSmall)};

    @media (min-width: ${theme.Screen.Size.Small}px) {
      min-height: ${PRESETS.iconsWrapper.minHeightSmall};
      grid-template-columns: repeat(
        auto-fill,
        minmax(calc(14.285% - ${utils.rem(theme.Spacing.Size.MediumSmall)}), 1fr)
      );
    }
  `
);

export const StyledClaimCreditsButton = styled.div`
  ${({ theme }) => `
    margin-top: 0;

    @media (min-width: ${theme.Screen.Size.Medium}px) {
      margin-top: -${utils.rem(theme.Spacing.Size.Medium)};
    }
  `}
`;
